import {
  Button,
  NumberInput,
  ReferenceInput,
  required,
  SelectInput,
  TextInput,
  useNotify,
  useRefresh,
} from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import { Grid } from "@mui/material";
import FormModal from "server/components/Modals/FormModal";
import { useState } from "react";
import { studentRequests } from "api/studentApi";
import dataProvider from "server/dataProvider";

const ChangeGradeModal = ({ record, educationId, fetchGrades }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [newGarde, setNewGrade] = useState(record?.grade);

  const handleSubmit = async data => {
    const payload = {
      grade: Number(data.grade),
      reason: data.reason,
      comment: data.comment,
    };
    await dataProvider.customRequest(
      studentRequests.updateStudentDisciplineGrade(educationId, record.disciplineId),
      payload,
      "PUT",
    );
    refresh();
    await fetchGrades();
    notify(`Успешна редакция на оценка`, { type: "success" });
  };

  return (
    <FormModal
      titleContent={"Редакция на оценка"}
      onConfirm={handleSubmit}
      confirmEnabled={newGarde !== record?.grade}
      resetProps={() => setNewGrade(record?.grade)}
      triggerButton={
        <Button
          variant="contained"
          startIcon={<EditIcon />}
          size="small"
          label=""
        />
      }
    >
      <Grid
        container
        spacing={2}
        p={2}
        sx={{ borderLeft: "5px solid #4E2683", marginY: "0.5rem" }}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <NumberInput
            label="Оценка"
            source="grade"
            onChange={e => setNewGrade(e.target.value)}
            validate={required()}
            step={0.1}
            min={2}
            max={6}
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={6}
        >
          <ReferenceInput
            source="reason"
            reference={studentRequests.getGradeChangeReasonsSelect()}
          >
            <SelectInput
              label="Причина за промяна на оценка"
              optionText="nameBg"
              validate={required()}
              fullWidth
            />
          </ReferenceInput>
        </Grid>
        <Grid
          item
          xs={12}
        >
          <Grid
            item
            xs={12}
          >
            <TextInput
              source="comment"
              label="Коментар"
              variant="outlined"
              fullWidth
              multiline
              minRows={5}
              maxRows={5}
            />
          </Grid>
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default ChangeGradeModal;
